export default {
      id: "list-usage",
      viewBox: "0 0 17.655 11.896",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#list",
      toString: function () {
        return this.url;
      }
    }